import moment from "moment";
import { useWindowSize } from "PFCore/helpers/use_window_size";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { useIsUnbiasedMode } from "PFCore/hooks/use_is_unbiased_mode";
import PropTypes from "prop-types";
import { useMemo } from "react";

import CompareAvailabilityMobilePage from "./availability/compare_availability_mobile_page";
import CompareAvailabilityPage from "./availability/compare_availability_page";
import CompareHeader from "./common/compare_header";
import { CompareDetailsPage } from "./details/compare_details_page";

const ComparePage = ({ activity, comparableProfiles, tab, changeTab, removeProfileId }) => {
  const { formatISODate } = useDateFormatter();

  const profiles = (comparableProfiles || []).map((sh) => sh.profile);
  const availability = activity?.metadata?.availability || null;

  const startDate = useMemo(() => {
    let availabilityStartDate = moment();
    if (availability) {
      if (availability.mode === "time_rule") {
        availabilityStartDate = moment.min(availability.ranges.map((range) => moment(range.start)));
      } else {
        availabilityStartDate = moment(availability.start);
      }
    }
    return formatISODate(moment.max(moment(), availabilityStartDate).startOf("isoWeek").set("hour", 12));
  }, [availability, formatISODate]);

  const { windowWidth } = useWindowSize();

  const isUnbiasedMode = useIsUnbiasedMode(activity?.reviewers);

  return (
    <>
      <CompareHeader
        activity={activity}
        tabActiveId={tab}
        changeTab={changeTab}
        comparableProfiles={comparableProfiles}
      />

      {
        {
          details: (
            <CompareDetailsPage
              activity={activity}
              comparableProfiles={comparableProfiles}
              removeProfileId={removeProfileId}
              changeTab={changeTab}
              isUnbiasedMode={isUnbiasedMode}
            />
          ),
          availability:
            windowWidth > 800 ? (
              <CompareAvailabilityPage
                startDate={startDate}
                comparableProfiles={comparableProfiles}
                availabilityInfo={availability}
                removeProfileId={removeProfileId}
                isUnbiasedMode={isUnbiasedMode}
              />
            ) : (
              <CompareAvailabilityMobilePage profiles={profiles} isUnbiasedMode={isUnbiasedMode} />
            )
        }[tab]
      }
    </>
  );
};

ComparePage.propTypes = {
  activity: PropTypes.object.isRequired,
  comparableProfiles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      profile: PropTypes.shape({
        id: PropTypes.number,
        isAvailable: PropTypes.bool,
        availabilityMatch: PropTypes.number
      }),
      applicableCustomValues: PropTypes.arrayOf(
        PropTypes.shape({
          requiredExperience: PropTypes.number,
          experience: PropTypes.number,
          text: PropTypes.string,
          importance: PropTypes.number
        })
      )
    })
  ).isRequired,
  tab: PropTypes.oneOf(["details", "availability"]).isRequired,
  changeTab: PropTypes.func.isRequired,
  removeProfileId: PropTypes.func.isRequired,
  date: PropTypes.instanceOf(Date)
};

export default ComparePage;
